import { ComponentMultiStyleConfig } from '@chakra-ui/react'

export const Avatar: ComponentMultiStyleConfig = {
  parts: ['label'],

  baseStyle: {
    label: { fontFamily: 'Proxima Nova Semibold' },
  },
}
